<template>
    <div class="ds-segmented-picker__widget" v-if="$slots.default" v-show="name === selectedTabName">
        <slot></slot>
    </div>
</template>

<script lang="ts" setup>
import { inject } from "vue";
import { dsSegmentedInjectedKey } from "../segmented-picker/ds-segmented-injected-key";

defineProps<{
    /** Title of the tab */
    title: string;
    /** CodeName for unique identification */
    name: string;
}>();

const selectedTabName = inject(dsSegmentedInjectedKey);
</script>
